/** setTimeout keeps its delay in a signed 32-bit int; a larger one fires immediately, forever. */
export const MAX_TIMEOUT_DELAY_MS = 2_147_483_647;
